// extracted by mini-css-extract-plugin
module.exports = {"divider":"ipo_divider__NR1aW","ipo_details_content":"ipo_ipo_details_content__qTaEc","twoColumns":"ipo_twoColumns__ximKJ"};